module.exports = __webpack_public_path__ + "img/logo_branca.7fa18924.png";